<template>
  <v-dialog
      v-model="isVisibleWindow"
      scrollable
      max-width="1200"
      max-height="90%"
      min-width="90%"
      persistent
  >
    <div
    :class="{
      black: $vuetify.theme.dark,
      grey: $vuetify.theme.light,
      'lighten-2': $vuetify.theme.dark,
      'lighten-3': $vuetify.theme.light,
    }"
  >
    <v-card :loading="!isFetchedOrder || savingInProgress" elevation="0">
      <v-card-actions>
        <h1 id="orderTitle" class="pl-1" v-show="order && order.human_number">
          {{ $t("viewOrdersForm.title") }}
          {{ order && order.human_number }}
        </h1>
        <v-spacer></v-spacer>
        <v-btn icon @click="isVisibleWindow = false">
          <v-icon>fa-times</v-icon>
        </v-btn>
      </v-card-actions>
      <v-divider></v-divider>
      <v-card-text class="px-3">
        <v-form ref="orderForm" v-if="order && order.id">
          <v-row>
            <v-col
                cols="12"
                class="py-0"
            >
                <span
                    :title="
                    canGoToSearchWithOrder
                      ? $t('viewOrdersForm.go_to_search_with_order')
                      : $t('viewOrdersForm.cannot_go_to_search_with_order')
                  "
                >
                  <v-btn
                      elevation="0"
                      min-width="48"
                      :disabled="cartIsLoading || !canGoToSearchWithOrder"
                      :loading="cartIsLoading"
                      min-height="48"
                      class="mb-0 green--text px-0"
                      @click="
                      goToSearchWithOrder(
                        order.id,
                        order.human_number,
                        order.customer.id,
                        (order.car && order.car.id) || null
                      )
                    "
                      @keyup.enter="
                      goToSearchWithOrder(
                        order.id,
                        order.human_number,
                        order.customer.id,
                        (order.car && order.car.id) || null
                      )
                    "
                  >
                    <v-icon small>$cart</v-icon>
                  </v-btn>
                </span>
              <v-btn
                  elevation="0"
                  min-width="48"
                  min-height="48"
                  class="mb-0 green--text ml-2 px-0"
                  @click="bidWindow = true"
                  @keyup.enter="bidWindow = true"
                  :title="$t('viewOrdersForm.order_bid')"
              >
                <v-icon small>$bids</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="48"
                  min-height="48"
                  class="mb-0 red--text ml-2 px-0"
                  @click="calendarWindow = true"
                  @keyup.enter="calendarWindow = true"
                  :title="$t('viewOrdersForm.dates_in_calendar')"
                  v-if="userHasRight('calendar|view')"
                  id="datesInCalendarBtn"
              >
                <v-icon small>$calendar</v-icon>
              </v-btn>
              <v-btn
                  elevation="0"
                  min-width="48"
                  min-height="48"
                  class="mb-0 ml-2 px-0"
                  @click="
                  financeWindow.isVisible=true; financeWindow.order_id = order.id
                    financeWindow.isVisible=true; financeWindow.order_id = order.id
                  "
                  @keyup.enter="
                    financeWindow.isVisible=true; financeWindow.order_id = order.id
                  "
                  :title="$t('payments.finance')"
              >
                <v-icon small>fa-coins</v-icon>
              </v-btn>

              <v-badge
                  :value="logs.length > 0"
                  :content="logs.length"
                  overlap
              >
                <v-btn
                    elevation="0"
                    min-width="48"
                    min-height="48"
                    class="mb-0 ml-2 px-0"
                    :disabled="!(logs.length > 0)"
                    @click="historyWindow = true"
                    @keyup.enter="historyWindow = true"
                    :title="$t('viewOrdersForm.history')"
                >
                  <v-icon small>$history</v-icon>
                </v-btn>
              </v-badge>
              <v-btn
                  elevation="0"
                  min-width="48"
                  min-height="48"
                  class="mb-0 ml-2 px-0 light-blue--text"
                  @click="
                    commentWindow.isVisible = true;
                    commentWindow.orderId = order.id;
                  "
                  @keyup.enter="
                    commentWindow.isVisible = true;
                    commentWindow.orderId = order.id;
                  "
                  :title="$t('common.comment')"
              >
                <v-icon small>fa-comment</v-icon>
              </v-btn>
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      class="mb-0 ml-2 px-0"
                      v-on="on"
                      :title="$t('common.documents')"
                  >
                    <!--<v-icon small>$xlsx</v-icon>-->
                    <v-icon small>$document</v-icon>
                    <v-icon x-small>fa-chevron-down</v-icon>
                  </v-btn>
                </template>
                <v-list offset-y>
                  <v-list-item
                      v-for="item in documentsForPrinList.filter(
                        (el) => el.isVisible
                      )"
                  >
                    <v-list-item-title class="pointer">
                      <v-list-item-icon class="mr-0 my-0" v-if="item.icon"
                      ><v-icon small>{{
                          item.icon
                        }}</v-icon></v-list-item-icon
                      >
                      <v-list-item-icon class="mr-0 my-0" v-if="item.icon2"
                      ><v-icon small>{{
                          item.icon2
                        }}</v-icon></v-list-item-icon
                      >

                      <a
                          :target="item.href ? '_blank' : '_self'"
                          :href="item.href ? item.href : '#'"
                          @click="
                            () => {
                              item.click ? item.click() : null;
                            }
                          "
                      >
                        {{ item.title }}
                      </a>
                      <v-list-item-subtitle v-if="item.subtitle">{{
                          item.subtitle
                        }}</v-list-item-subtitle>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
              <span
                  :title="
                    order.car
                      ? $t('viewOrdersForm.inspection_report')
                      : $t('viewOrdersForm.you_have_to_select_car')
                  "
              >
                  <v-btn
                      :disabled="!order.car"
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      class="mb-0 ml-2 px-0"
                      color=""
                      @click="reportWindow = true"
                  >
                    <v-icon small>$checklist</v-icon>
                  </v-btn>
                </span>
              <span :title="$t('windowDiagnostic.title')">
                  <v-btn
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      class="mb-0 ml-2 px-0 blue--text"
                      color=""
                      v-if="
                      order &&
                      order.items &&
                      order.items.find((item) => item.idx === 'spec_diag')
                    "
                      @click="
                      showDiagnosticWindow(
                        order.items.find((item) => item.idx === 'spec_diag')
                      )
                    "
                  >
                    <v-icon small> fa-tasks </v-icon>
                  </v-btn>
                </span>

              <span
                  :title="$t('goods.reserved_goods')"
                  v-if="isEnabledStorageV2"
              >
                  <v-btn
                      elevation="0"
                      min-width="48"
                      min-height="48"
                      class="mb-0 ml-2 px-0 blue--text"
                      color=""
                      :disabled="
                      !(
                        order &&
                        order.items.filter((el) => el.item_type == 'part')
                          .length
                      ) || order.status.name === 'received_delivered'
                    "
                      @click="showReservedGoods"
                  >
                    <v-icon small> mdi-alert-decagram-outline </v-icon>
                  </v-btn>
                </span>
              <span
                  :title="
                    order.car && order.car.vin
                      ? ''
                      : $t('viewOrdersForm.car_vin_not_found')
                  "
              >
<!--                  <v-btn-->
<!--                      min-height="48"-->
<!--                      min-width="48"-->
<!--                      class="mb-0 white&#45;&#45;text ml-2 green-shadow"-->
<!--                      :disabled="!order.car || !order.car.vin"-->
<!--                      color="success"-->
<!--                      @click="orderCheck()"-->
<!--                      :title="$t('viewOrdersForm.check_order_status')"-->
<!--                  >-->
<!--                    <v-icon small>$check</v-icon>-->
<!--                  </v-btn>-->
                </span>
            </v-col>
          </v-row>
            <v-row>
              <v-col
                cols="12"
                class="d-flex py-2 pb-1"
                :class="{
                  'align-end text-right': $vuetify.breakpoint.mdAndUp,
                }"
                sm="12"
                md="12"
                lg="5"
              >
                <span class="d-inline-block pr-3 pt-1 pr-md-7 pl-md-4">
                  <span class="text-caption grey--text text-no-wrap">{{
                    $t("viewOrders.tableHeader.total_sum")
                  }}:</span>
                  <br />
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <strong v-bind="attrs" v-on="on">
                        <span class="text-no-wrap">
                        {{ formatCurrency(totalSum) }}
                        </span>
                      </strong>
                    </template>
                    <span
                      >{{ $t("viewOrdersForm.parts") }}: {{ sumParts }} |
                      {{ $t("viewOrdersForm.repairtimes") }}:
                      {{ sumRepairtimes }}</span
                    >
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <span class="text--red text-no-wrap" v-bind="attrs" v-on="on">
                        {{ costs > 0 ? ("-" + formatCurrency(costs))  : "" }}
                      </span>
                    </template>
                    <span>{{ $t("costs.costs") }}</span>
                  </v-tooltip>
                </span>
                <span class="d-inline-block pr-3 pt-1 pr-md-7 pl-md-4">
                  <span class="text-caption grey--text text-no-wrap">{{
                    $t("common.total_purchase_sum")
                  }}:</span
                  ><br />
                  <strong class="text-no-wrap">{{ formatCurrency(totalPurchaseSum) }}</strong>
                </span>
                <span class="d-inline-block pr-3 pt-1 pr-md-7 pl-md-4">
                  <span class="text-caption grey--text">{{
                    $t("common.payed")
                  }}:</span
                  ><br />
                  <strong class="text-no-wrap">{{ formatCurrency(payed) }}</strong>
                </span>
                <span class="d-inline-block pr-3 pt-1 pr-md-7 pl-md-4">
                  <span class="text-caption grey--text text-no-wrap">{{
                    $t("common.debt")
                  }}:</span
                  ><br />
                  <strong class="text--red text-no-wrap">{{ formatCurrency(debt) }}</strong>
                </span>
              </v-col>
            </v-row>

            <v-divider class="pt-0 mt-0 pb-4"></v-divider>
            <!--таблица с запчастями--->
            <order-form-parts-table
              @update="orderUpdate"
              @refresh="()=>loadOrder(order.id)"
              :order="order"
              v-if="tableType === 'parts'"
              :data="order.items.filter((el) => el.item_type == 'part')"
              id="partsTable"
              height="auto"
            ></order-form-parts-table>

            <!-- таблица с работами-->
            <v-data-table
              v-if="tableType == 'repairtimes'"
              :headers="[
                {
                  text: $t('common.title'),
                  value: 'name',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.repairtime'),
                  value: 'time',
                  align: 'right',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.amount'),
                  value: 'amount',
                  align: 'center',
                  width: '200px',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.price'),
                  value: 'price',
                  align: 'right',
                  class: 'text-no-wrap',
                },
                { text: $t('common.total_sum'), class: 'text-no-wrap' },
              ]"
              :items="order.items.filter((el) => el.item_type == 'repairtime')"
              hide-default-footer
              class="lighten-5 ma-0 elevation-0"
              dense
              id="repairtimesTable"
              height="auto"
            >
              <template v-slot:item="items">
                <tr>
                  <td class="text-left">
                    <v-icon small class="mr-1" color="red">$tools</v-icon>
                    <v-icon
                      small
                      class="pointer mr-2"
                      v-if="items.item.idx === 'spec_diag'"
                      @click="showDiagnosticWindow(items.item)"
                    >
                      fa-tasks
                    </v-icon>
                    <v-icon
                      x-small
                      class="pointer"
                      @click="showItemImagesWindow(items.item)"
                    >
                      fa-images
                    </v-icon>
                    <!--- название работы -->
                    {{ items.item.name }}
                  </td>
                  <td class="text-right">{{ items.item.time }}</td>
                  <td class="text-center">
                    <v-container
                      class="justify-center d-flex"
                      style="width: 100px"
                    >
                      <v-row class="mx-0" justify="center" no-gutters>
                        <v-col class="pa-0">
                          <v-btn
                            max-width="17"
                            max-height="17"
                            outlined
                            color="pink darken-1"
                            fab
                            x-small
                            :disabled="savingInProgress || !isFetchedOrder"
                            @click="
                              () => {
                                items.item.amount--;
                                orderUpdate();
                              }
                            "
                            >-
                          </v-btn>
                        </v-col>
                        <v-col class="pa-0">
                          <edit-value-menu
                              :item="items.item"
                              :field-name="'amount'"
                              @update="(item)=>{props.item.amount = item.amount;orderUpdate();}"
                              :disabled=" ! (items.item.nomenclature &&
                          items.item.nomenclature.unit_of_measurement &&
                          items.item.nomenclature.unit_of_measurement.is_divisible &&
                          items.item.nomenclature.unit_of_measurement.is_divisible === 1) || !isEnabledStorageV2"
                          />
                        </v-col>
                        <v-col class="pa-0">
                          <v-btn
                            max-width="17"
                            max-height="17"
                            outlined
                            color="success"
                            depressed
                            fab
                            x-small
                            :disabled="savingInProgress || !isFetchedOrder"
                            @click="
                              items.item.amount++;
                              orderUpdate();
                            "
                            >+
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </td>
                  <td class="text-right">
                    <v-menu
                      v-model="priceMenu[items.item.id]"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on" @click="priceTmp = items.item.price">
                          {{ formatCurrency(items.item.price) }}
                        </a>
                      </template>

                      <v-card>
                        <v-list>
                          <v-list-item>
                            <v-list-item-content>
                              <v-text-field
                                :placeholder="$t('common.price')"
                                v-model="priceTmp"
                                required
                                type="numeric"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    $t(
                                      'form.validationErrors.field_is_required'
                                    ),
                                ]"
                              ></v-text-field>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            text
                            @click="priceMenu[items.item.id] = false"
                            >{{ $t("common.cancel") }}</v-btn
                          >
                          <v-btn
                            color="primary"
                            text
                            @click="
                              priceMenu[items.item.id] = false;
                              items.item.price = priceTmp;
                              orderUpdate();
                            "
                          >
                            {{ $t("common.save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </td>
                  <td class="text-right">
                    {{
                      parseFloat(items.item.price * items.item.amount).toFixed(
                        2
                      )
                    }}
                  </td>
                  <td class="text-right">
                    <!-- статус работы -->
                    <v-select
                      class="no-line-select"
                      xs6
                      hide-details
                      :items="order_repairtimes_statuses"
                      :label="$t('viewOrdersForm.status_repairtime')"
                      item-text="name"
                      return-object
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                      v-model="items.item.status"
                      @input="orderUpdate"
                    >
                      <template v-slot:selection="{ item }">
                        <span class="text-no-wrap">
                          <span
                            :style="{
                              background: item.color,
                              color: getCorrectTextColor(item.color),
                            }"
                            class="pa-1 d-inline-block mr-1 status-square"
                          ></span>
                          {{
                            item.type === "shop_order_repairtime_status"
                              ? item.name
                              : $t(
                                  "common.orderPartsSystemStatusNames." +
                                    item.name
                                )
                          }}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <span
                          :style="{
                            background: item.color,
                            color: getCorrectTextColor(item.color),
                          }"
                          class="pa-1 d-block mr-2 status-square"
                        ></span>
                        {{
                          item.type === "shop_order_repairtime_status"
                            ? item.name
                            : $t(
                                "common.orderPartsSystemStatusNames." +
                                  item.name
                              )
                        }}
                      </template>
                    </v-select>
                  </td>
                </tr>
              </template>
              <template v-slot:body.append="items">
                <tr class="text-xs-left">
                  <td colspan="2" class="text-sm-right"></td>
                  <td class="text-center">
                    <strong>{{
                      Object.values(items.items).reduce(
                        (sum, item) => parseInt(item.amount) + parseInt(sum),
                        0
                      )
                    }}</strong>
                  </td>
                  <td class="text-sm-right"></td>
                  <td class="text-sm-right text-no-wrap">
                    <strong>{{
                        formatCurrency(Object.values(items.items).reduce(
                        (sum, item) =>
                          (
                            parseFloat(item.price * item.amount) +
                            parseFloat(sum)
                          ).toFixed(2),
                        0
                      ))
                    }}</strong>
                  </td>
                  <td class="text-sm-right"></td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>

            <!-- таблица с работами и запчастями-->
            <v-data-table
              no-data="33"
              v-if="tableType == 'summary'"
              :headers="[
                { text: '', value: 'data-table-expand' },
                {
                  text: $t('common.title'),
                  value: 'name',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.repairtime'),
                  value: 'time',
                  align: 'right',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.amount'),
                  value: 'amount',
                  align: 'center',
                  width: '200px',
                  class: 'text-no-wrap',
                },
                {
                  text: $t('common.price'),
                  value: 'price',
                  align: 'right',
                  class: 'text-no-wrap',
                },
                { text: $t('common.total_sum'), class: 'text-no-wrap' },
                { text: $t('common.status'), class: 'text-no-wrap' },
              ]"
              :items="order.items.filter((el) => el.item_type == 'repairtime')"
              :expanded.sync="expanded"
              show-expand
              class="elevation-0 mb-3"
              hide-default-footer
            >
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:item="items">
                <tr>
                  <td class="pa-0 pl-1">
                    <v-btn
                      depressed
                      fab
                      x-small
                      @click="toggleExpanded(items.item)"
                      v-if="
                        order.items.filter(
                          (el) =>
                            el.item_type == 'part' &&
                            el.repairtime_id_in_order == items.item.id
                        ).length
                      "
                    >
                      <v-icon v-if="expanded.includes(items.item)"
                        >mdi-chevron-up</v-icon
                      >
                      <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                  </td>
                  <td class="text-left">
                    <v-icon small class="mr-1" color="red">$tools</v-icon>
                    <v-icon
                      small
                      class="pointer mr-2"
                      v-if="items.item.idx === 'spec_diag'"
                      @click="showDiagnosticWindow(items.item)"
                    >
                      fa-tasks
                    </v-icon>
                    <v-icon
                      x-small
                      class="pointer"
                      @click="showItemImagesWindow(items.item)"
                    >
                      fa-images
                    </v-icon>
                    <!--- название работы -->
                    {{ items.item.name }}
                    <template
                      v-if="
                        order.items.filter(
                          (el) =>
                            el.item_type == 'part' &&
                            el.repairtime_id_in_order == items.item.id
                        ).length
                      "
                    >
                      <!-- Деталей:  -->
                      <br/>
                      <span class="mr-5 grey--text text--lighten-1">
                        {{ $t("componentMultiCart.parts_num") }}:
                        {{
                          Object.values(
                            order.items.filter(
                              (el) =>
                                el.item_type == "part" &&
                                el.repairtime_id_in_order == items.item.id
                            )
                          ).reduce(
                            (sum, it) => parseInt(it.amount) + parseInt(sum),
                            0
                          )
                        }}
                      </span>
                      <!-- на сумму:  -->
                      <span class="ml-5 grey--text text--lighten-1">
                        {{ $t("componentMultiCart.on_sum") }}:
                        {{
                          formatCurrency(Object.values(
                            order.items.filter(
                              (el) =>
                                el.item_type == "part" &&
                                el.repairtime_id_in_order == items.item.id
                            )
                          ).reduce(
                            (sum, item) =>
                              (
                                parseFloat(item.price * item.amount) +
                                parseFloat(sum)
                              ).toFixed(2),
                            0
                          ))
                        }}
                      </span>
                    </template>
                  </td>
                  <td class="text-right">{{ items.item.time }}</td>
                  <td class="text-center">
                    <v-container
                      class="justify-center d-flex"
                      style="width: 100px"
                    >
                      <v-row class="mx-0" justify="center" no-gutters>
                        <v-col class="pa-0">
                          <v-btn
                            max-width="17"
                            max-height="17"
                            outlined
                            color="pink darken-1"
                            fab
                            x-small
                            :disabled="savingInProgress || !isFetchedOrder"
                            @click="
                              () => {
                                items.item.amount--;
                                orderUpdate();
                              }
                            "
                            >-
                          </v-btn>
                        </v-col>
                        <v-col class="pa-0">
                          {{ items.item.amount }}
                        </v-col>
                        <v-col class="pa-0">
                          <v-btn
                            max-width="17"
                            max-height="17"
                            outlined
                            color="success"
                            depressed
                            fab
                            x-small
                            :disabled="savingInProgress || !isFetchedOrder"
                            @click="
                              items.item.amount++;
                              orderUpdate();
                            "
                            >+
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-container>
                  </td>
                  <td class="text-right">
                    <v-menu
                      v-model="priceMenu[items.item.id]"
                      :close-on-content-click="false"
                      :nudge-width="200"
                      offset-x
                    >
                      <template v-slot:activator="{ on }">
                        <a v-on="on" @click="priceTmp = items.item.price" class="text-no-wrap">
                          {{ formatCurrency(items.item.price) }}
                        </a>
                      </template>

                      <v-card>
                        <v-list>
                          <v-list-item>
                            <v-list-item-content>
                              <v-text-field
                                :placeholder="$t('common.price')"
                                v-model="priceTmp"
                                required
                                type="numeric"
                                :rules="[
                                  (v) =>
                                    !!v ||
                                    $t(
                                      'form.validationErrors.field_is_required'
                                    ),
                                ]"
                              ></v-text-field>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>

                        <v-divider></v-divider>

                        <v-card-actions>
                          <v-spacer></v-spacer>

                          <v-btn
                            text
                            @click="priceMenu[items.item.id] = false"
                            >{{ $t("common.cancel") }}</v-btn
                          >
                          <v-btn
                            color="primary"
                            text
                            @click="
                              priceMenu[items.item.id] = false;
                              items.item.price = priceTmp;
                              orderUpdate();
                            "
                          >
                            {{ $t("common.save") }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-menu>
                  </td>
                  <td class="text-right text-no-wrap">
                    {{
                      formatCurrency(parseFloat(items.item.price * items.item.amount).toFixed(
                        2
                      ))
                    }}
                  </td>
                  <td class="text-right">
                    <!-- статус работы -->
                    <v-select
                      class="no-line-select"
                      xs6
                      hide-details
                      :items="order_repairtimes_statuses"
                      :label="$t('viewOrdersForm.status_repairtime')"
                      item-text="name"
                      return-object
                      :rules="[
                        (v) =>
                          !!v || $t('form.validationErrors.field_is_required'),
                      ]"
                      v-model="items.item.status"
                      @input="orderUpdate"
                    >
                      <template v-slot:selection="{ item }">
                        <span class="text-no-wrap">
                          <span
                            :style="{
                              background: item.color,
                              color: getCorrectTextColor(item.color),
                            }"
                            class="pa-1 d-inline-block mr-1 status-square"
                          ></span>
                          {{
                            item.type === "shop_order_repairtime_status"
                              ? item.name
                              : $t(
                                  "common.orderPartsSystemStatusNames." +
                                    item.name
                                )
                          }}
                        </span>
                      </template>
                      <template v-slot:item="{ item }">
                        <span
                          :style="{
                            background: item.color,
                            color: getCorrectTextColor(item.color),
                          }"
                          class="pa-1 d-block mr-2 status-square"
                        ></span>
                        {{
                          item.type === "shop_order_repairtime_status"
                            ? item.name
                            : $t(
                                "common.orderPartsSystemStatusNames." +
                                  item.name
                              )
                        }}
                      </template>
                    </v-select>
                  </td>
                </tr>
              </template>
              <template v-slot:expanded-item="{ headers, item }">
                <td :colspan="headers.length" class="px-0">
                  <order-form-parts-table
                    @update="orderUpdate"
                    @refresh="()=>loadOrder(order.id)"
                    :order="order"
                    :data="
                      order.items.filter(
                        (el) =>
                          el.item_type == 'part' &&
                          el.repairtime_id_in_order == item.id
                      )
                    "
                    id="partsTable"
                    height="auto"
                  ></order-form-parts-table>
                </td>
              </template>
              <template v-slot:body.append="items">
                <tr>
                  <td class="pa-0 pl-1">
                    <v-btn
                      depressed
                      fab
                      x-small
                      @click="showUnattachedParts = !showUnattachedParts"
                      v-if="
                        order.items.filter(
                          (el) =>
                            el.item_type == 'part' &&
                            el.repairtime_id_in_order == null
                        ).length > 0
                      "
                    >
                      <v-icon v-if="showUnattachedParts">mdi-chevron-up</v-icon>
                      <v-icon v-else>mdi-chevron-down</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <template
                      v-if="
                        order.items.filter(
                          (el) =>
                            el.item_type == 'part' &&
                            el.repairtime_id_in_order == null
                        ).length
                      "
                    >
                      <v-icon class="mr-1" small color="black"
                        >$gear_tools</v-icon
                      ><i>{{
                        $t("componentMultiCart.parts_without_repairtimes")
                      }}</i>
                      <br />

                      <!-- Деталей:  -->

                      <span class="mr-5 grey--text text--lighten-1">
                        {{ $t("componentMultiCart.parts_num") }}:
                        {{
                          Object.values(
                            order.items.filter(
                              (el) =>
                                el.item_type == "part" &&
                                el.repairtime_id_in_order == null
                            )
                          ).reduce(
                            (sum, it) => parseInt(it.amount) + parseInt(sum),
                            0
                          )
                        }}
                      </span>
                      <!-- на сумму:  -->
                      <span class="ml-5 grey--text text--lighten-1">
                        {{ $t("componentMultiCart.on_sum") }}:
                        {{
                          formatCurrency(Object.values(
                            order.items.filter(
                              (el) =>
                                el.item_type == "part" &&
                                el.repairtime_id_in_order == null
                            )
                          ).reduce(
                            (sum, it) =>
                              (
                                parseFloat(it.price * it.amount) +
                                parseFloat(sum)
                              ).toFixed(2),
                            0
                          ))
                        }}
                      </span>
                    </template>
                    <template v-else>
                      <i>{{
                        $t("componentMultiCart.none_parts_without_repairtimes")
                      }}</i>
                    </template>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <tr
                  v-if="
                    showUnattachedParts &&
                    order.items.filter(
                      (el) =>
                        el.item_type == 'part' &&
                        el.repairtime_id_in_order == null
                    ).length
                  "
                >
                  <td colspan="7" class="pa-0 ma-0">
                    <order-form-parts-table
                      @update="orderUpdate"
                      @refresh="()=>loadOrder(order.id)"
                      :order="order"
                      :data="
                        order.items.filter(
                          (el) =>
                            el.item_type == 'part' &&
                            el.repairtime_id_in_order == null
                        )
                      "
                      id="partsTable"
                      height="auto"
                    ></order-form-parts-table>
                  </td>
                </tr>
              </template>
              <template v-slot:no-data>
                {{ $t("common.no_data_available") }}
              </template>
              <template v-slot:no-results>
                {{ $t("common.no_data_available") }}
              </template>
            </v-data-table>
            <v-divider class="mt-4"></v-divider>
            <v-row class="pr-5 mb-2">
              <v-col cols="3">
                <p class="ma-0 mt-2">
                  <span class="text-caption"
                    >{{ $t("common.customer") }}:</span
                  >
                  <span
                    v-if="order.customer"
                    @click="
                      customerId = order.customer.id;
                      customerEditForm = true;
                      customerFormTabsId = 0;
                    "
                    class="dashed"
                  >
                    {{ order.customer.last_name }}
                    {{ order.customer.first_name }}
                    {{ order.customer.patronymic }}
                  </span>
                  <span v-else>
                    {{ $t("viewOrders.customer_is_deleted") }}
                  </span>
                </p>
                <p
                  class="ma-0"
                  v-if="order.customer && order.customer.is_company == 1"
                >
                  <span class="text-caption"
                    >{{ $t("common.legal_name") }}:</span
                  >
                  <strong
                    @click="
                      customerId = order.customer.id;
                      customerEditForm = true;
                      customerFormTabsId = 0;
                    "
                    class="dashed"
                    >{{
                      order.customer.is_company == 1
                        ? "[" + order.customer.legal_name + "]"
                        : ""
                    }}</strong
                  >
                </p>
                <p class="ma-0" @click="showGarageForSelectCar(order)">
                  <span class="text-caption">{{ $t("common.car") }}:</span>
                  <span :class="{ dashed: order.customer }">
                    {{ order.car ? order.car.name : "" }}
                  </span>
                  <beauty-car-number
                    class="d-inline-block ml-2"
                    v-if="order.car && order.car.car_number"
                    :number="order.car.car_number"
                  >
                  </beauty-car-number>
                  <span v-if="!order.car" class="dashed">{{
                    $t("common.not_selected")
                  }}</span>
                </p>
              </v-col>
              <v-col cols="3">
                <p class="ma-0 mt-2">
                  <span class="text-caption d-block"
                    >{{ $t("viewOrdersForm.responsible_for_order") }}:</span
                  >
                  <v-btn
                    fab
                    x-small
                    elevation="0"
                    height="24"
                    width="24"
                    class="mr-2"
                    @click="responsibleWindow = true"
                  >
                    <v-icon x-small color="grey">$pencil</v-icon>
                  </v-btn>
                  <template
                    v-if="order.responsible_for && order.responsible_for.length"
                  >
                    <span v-for="resp in order.responsible_for">
                      <strong>{{
                        resp && resp.stage && resp.stage.name || "Deleted"
                      }}</strong
                      >:
                      {{
                        resp &&
                        resp.responsible_user &&
                        resp.responsible_user.name
                      }},
                    </span>
                  </template>
                  <template v-else>
                    {{
                      order.created_by_user ? order.created_by_user.name : ""
                    }}
                  </template>
                </p>
              </v-col>
              <v-col col-md="auto" cols="4">
                <span class="d-inline-block pt-1 ">
                  <v-select
                    class="no-line-select"
                    xs6
                    md4
                    hide-details
                    :items="order_statuses"
                    :label="$t('viewOrdersForm.status')"
                    item-text="name"
                    return-object
                    :rules="[
                      (v) =>
                        !!v || $t('form.validationErrors.field_is_required'),
                    ]"
                    :value="order.status"
                    @change="setOrderStatus"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-no-wrap">
                        <span
                          :style="{
                            background: item.color,
                            color: getCorrectTextColor(item.color),
                          }"
                          class="pa-1 d-inline-block mr-1 status-square"
                        ></span>
                        {{
                          item.system
                            ? $t("common.orderSystemStatusNames." + item.name)
                            : item.name
                        }}
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :style="{
                          background: item.color,
                          color: getCorrectTextColor(item.color),
                        }"
                        class="pa-1 d-block mr-2 status-square"
                      ></span>
                      {{
                        item.system
                          ? $t("common.orderSystemStatusNames." + item.name)
                          : item.name
                      }}
                    </template>
                  </v-select>
                </span>
              </v-col>
              <v-col col-md="auto" cols="2">
                <span class="d-inline-block">
                  <v-select
                    class="no-line-select"
                    xs6
                    hide-details
                    :items="order_payments_statuses"
                    :label="$t('viewOrdersForm.payment_status')"
                    item-text="name"
                    return-object
                    :rules="[
                      (v) =>
                        !!v || $t('form.validationErrors.field_is_required'),
                    ]"
                    v-model="order.status_payment"
                    @change="orderUpdate"
                  >
                    <template v-slot:selection="{ item }">
                      <span class="text-no-wrap">
                        <span
                          :style="{
                            background: item.color,
                            color: getCorrectTextColor(item.color),
                          }"
                          class="pa-1 d-inline-block mr-1 status-circle"
                        ></span>
                        {{
                          item.system
                            ? $t("common.paymentStatuses." + item.name)
                            : item.name
                        }}
                      </span>
                    </template>
                    <template v-slot:item="{ item }">
                      <span
                        :style="{
                          background: item.color,
                          color: getCorrectTextColor(item.color),
                        }"
                        class="pa-1 d-block mr-2 status-circle"
                      ></span>
                      {{
                        item.system
                          ? $t("common.paymentStatuses." + item.name)
                          : item.name
                      }}
                    </template>
                  </v-select>
                </span>
              </v-col>
            </v-row>
            <h2 v-if="order.user_comment">
              {{ $t("viewOrdersForm.customer_comment") }}
            </h2>
            {{ order.user_comment }}
          </v-form>
      </v-card-text>
    </v-card>
    <div v-if="order && order.id">
    <v-dialog v-model="historyWindow" scrollable max-width="900px">
      <v-card class="pa-3">
        <h3 class="pa-3 pt-2">{{ $t("viewOrdersForm.history") }}</h3>
        <table style="max-height: 400px" class="mx-3 overflow-y-auto d-block">
          <tr v-for="item in logs" class="px-3 pb-2 d-block">
            <td class="text-no-wrap" valign="top" style="min-width: 120px;">
              <span class="text-caption">{{ item.date | moment("DD.MM.YYYY HH:mm") }}</span>
            </td>
            <td class="text-no-wrap" valign="top">
              <b>[{{ item.user }}]</b>
            </td>
            <td valign="top">
              <span v-html="item.action"></span>
            </td>
          </tr>
        </table>
        <v-layout class="pa-3 pt-2">
          <v-row>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" class="text-right px-0 py-0">
              <v-btn
                class="mr-2 mt-4"
                color="primary"
                elevation="0"
                @click="historyWindow = false"
                @keyup.enter="historyWindow = false"
              >
                {{ $t("common.close") }}
              </v-btn></v-col
            >
          </v-row>
        </v-layout>
      </v-card>
    </v-dialog>
    <order-messages-window
      :order-id="commentWindow.orderId"
      :show="commentWindow.isVisible"
      @hide="commentWindow.isVisible = false"
    ></order-messages-window>
    <v-dialog v-model="customerEditForm" scrollable max-width="890">
      <customerForm
        @removed="customerEditForm=false"
        :is-visible="customerEditForm"
        @store="
          (data) => {
            this.order.customer = data;
            customerEditForm = false;
            orderUpdate();
          }
        "
        :customer-id="customerId"
      ></customerForm>
    </v-dialog>
    <v-dialog v-model="customerGarageSelectCarForm" scrollable max-width="890">
      <customerForm
        @removed="customerGarageSelectCarForm=false"
        :is-visible="customerGarageSelectCarForm"
        @store="
          (data) => {
            this.order.customer = data;
            customerEditForm = false;
            orderUpdate();
          }
        "
        :customer-id="customerId"
        :car-id="carId"
        @chooseCar="chooseCar"
      ></customerForm>
    </v-dialog>
    <v-dialog v-model="carEditForm" scrollable max-width="890">
      <carForm
        :show="carEditForm"
        :car-id="order && order.car && order.car.id"
        @removed="carEditForm=false; order.car=null"
        @store="
          (data) => {
            order.car = data;
            carEditForm = false;
          }
        "
      ></carForm>
    </v-dialog>
    <order-finance-window :show="financeWindow.isVisible" :order_id="financeWindow.order_id" @hide="financeWindow.isVisible=false; loadOrder(order.id)"/>
    <v-dialog v-model="responsibleWindow" scrollable max-width="600" persistent>
      <OrderResponsibleForForm
        :order="order"
        @store="
          (data) => {
            responsibleWindow = false;
          }
        "
        @cancel="
          responsibleWindow = false;
          loadOrder(order.id);
        "
      />
    </v-dialog>
    <calendarForm
      :order-id="order.id"
      :show="calendarWindow"
      @hide="calendarWindow = false"
    />
    <bid-window
      :show="bidWindow"
      :bid-id="order.bid_id"
      :customer="order.customer"
      @hide="bidWindow = false"
      @update="(bid) => (order.bid = bid)"
    />
    <inspectionReportForm
      :order-id="order.id"
      :show="reportWindow"
      @hide="reportWindow = false"
    />
    <order-receipt-window
      :presenter="receiptWindow.presenter"
      :order-id="order.id"
      :show="receiptWindow.isVisible"
      @hide="receiptWindow.isVisible = false"
    ></order-receipt-window>
    <diagnostic-window
      :show="orderItemDiagnosticWindow.isVisible"
      :item="orderItemDiagnosticWindow.item"
      @hide="orderItemDiagnosticWindow.isVisible = false"
    ></diagnostic-window>
    <order-item-images-window
      :loading="imageLoading || !isFetchedOrder"
      :show="orderItemImagesWindow.isVisible"
      :item="orderItemImagesWindow.item"
      @hide="orderItemImagesWindow.isVisible = false"
      @remove="(id) => removeOrderItemImages(id)"
      @store="(files) => addOrderItemImages(files)"
    ></order-item-images-window>
    <reserved-goods-window
      :show="reservedGoodsWindow.isVisible"
      :items="reservedGoodsWindow.items"
      @hide="
        reservedGoodsWindow.isVisible = false;
        reservedGoodsWindow.items = null;
      "
    />
    </div>
  </div>
  </v-dialog>
</template>
<script>
import { required, email, sameAs, minLength } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import CustomerGarage from "@/components/customer/CustomerGarage.vue";
import CarForm from "@/components/garage/CarForm.vue";
import OrderFormPartsTable from "./OrderFormPartsTable";
import OrderResponsibleForForm from "./OrderResponsibleForForm";
import BeautyCarNumber from "../common/BeautyCarNumber";
import CalendarForm from "../calendar/CalendarForm";
import InspectionReportForm from "./InspectionReportForm";
import CommonMixin from "@/mixins/common";
import RightsMixin from "@/mixins/rights";
import OrderMessagesWindow from "@/components/order/OrderMessagesWindow";
import BidWindow from "../bid/BidWindow";
import OrderReceiptWindow from "./OrderReceiptWindow";
import OrderItemImagesWindow from "./OrderItemImagesWindow";
import DiagnosticWindow from "@/components/order/DiagnosticWindow";
import { CONSTANTS } from "@/constants/constants";
import ReservedGoodsWindow from "@/components/storage/ReservedGoodsWindow";
import i18n from "@/i18n";
import axios from "axios";
import OrderFinanceWindow from "@/components/order/OrderFinanceWindow.vue";
import EditValueMenu from "@/components/common/EditValueMenu.vue";
export default {
  name: "OrderWindow",
  components: {
    EditValueMenu,
    OrderFinanceWindow,
    ReservedGoodsWindow,
    DiagnosticWindow,
    OrderItemImagesWindow,
    OrderReceiptWindow,
    BidWindow,
    CalendarForm,
    BeautyCarNumber,
    InspectionReportForm,
    OrderFormPartsTable,
    customerForm: () => import("@/components/customer/CustomerForm.vue"),
    CarForm,
    CustomerGarage,
    OrderResponsibleForForm,
    OrderMessagesWindow,
  },
  mixins: [CommonMixin, RightsMixin],
  props: {
    orderId:null,
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    financeWindow:{
      isVisible:null,
      order_id:null
    },
    orderItemDiagnosticWindow: {
      isVisible: false,
      item: null,
    },
    orderItemImagesWindow: {
      isVisible: false,
      item: null,
    },
    reservedGoodsWindow: {
      isVisible: false,
      items: null,
    },
    showUnattachedParts: false,
    customerId: false,
    responsibleWindow: false,
    calendarWindow: false,
    bidWindow: false,
    reportWindow: false,
    customerEditForm: false,
    customerGarageSelectCarForm: false,
    carEditForm: false,
    receiptWindow: {
      presenter: null,
      isVisible: false,
    },
    commentWindow: {
      isVisible: false,
      orderId: false,
    },
    historyWindow: false,
    orderPartForChangeSuplier: null,
    purchasePriceMenu: {},
    purchasePriceTmp: null,
    partImage: null,
    carId: null,
    interval: null,
    expanded: [],
    priceMenu: {},
    priceTmp: null,
    order: {}
  }),

  validations() {
    return {
      customer: {
        email: { required, email },
      },
    };
  },

  mounted() {
    this.$store.dispatch("statuses/statusesGet", { id: this.$route.params.id })
  },
  watch: {
    order(to, from) {
      if (to.id !== from.id) this.orderCheckResult();
      this.refreshOrderItemWindow();
      if(to.id){
        if(this.order.order_check_status===null){
          this.orderCheck()
        }
      }
    },
    orderId(id){
      if(!id) return;
      this.loadOrder(id)
    }
  },
  computed: {
    isVisibleWindow: {
      get() {
        return this.isVisible;
      },
      set() {
        this.order = {};
        this.$emit("hide");
      },
    },
    documentsForPrinList() {
      return [
        {
          href: `${this.$apiURL}/orders/${this.order.id}/order-list`,
          title: this.$t("viewOrdersForm.order_list"),
          isVisible: true,
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/order-sales-receipt`,
          title: this.$t("viewOrdersForm.order_sales_receipt"),
          isVisible: true,
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/work-order`,
          title: this.$t("viewOrdersForm.work_order"),
          isVisible: true,
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/bill`,
          title: this.$t("viewOrdersForm.bill"),
          isVisible: true,
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/bill/concatenated`,
          title: this.$t("viewOrdersForm.bill"),
          subtitle: this.$t(
            "viewOrdersForm.concatenated_parts_and_repairtimes_subtitle"
          ),
          isVisible: true,
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/services-act-concatenated`,
          title: this.$t("viewOrdersForm.services_act_concatenated_title"),
          subtitle: this.$t(
            "viewOrdersForm.concatenated_parts_and_repairtimes_subtitle"
          ),
          isVisible: this.lang === "ru",
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/application-contract/concatenated`,
          title: this.$t("viewOrdersForm.application_contract"),
          subtitle: this.$t(
            "viewOrdersForm.concatenated_parts_and_repairtimes_subtitle"
          ),
          isVisible: this.lang === "ru",
        },

        {
          href: `${this.$apiURL}/orders/${this.order.id}/personal_data_form`,
          title: this.$t("viewOrdersForm.personal_data_form"),
          isVisible: false,
        },

        {
          icon: "fa-receipt",
          click: () => {
            this.receiptWindow.isVisible = true;
            this.receiptWindow.presenter = null;
          },
          title: this.$t("viewOrdersForm.receipt"),
          subtitle: this.$t("viewOrdersForm.receipt_std_subtitle"),
          isVisible: this.isShowReceiptPrintMenuItem && this.lang === "ru",
        },

        {
          icon: "fa-receipt",
          icon2: "mdi-vector-union",
          click: () => {
            this.receiptWindow.isVisible = true;
            this.receiptWindow.presenter =
              "OrderConcatenatedRepairtimesWithParts";
          },
          title: this.$t("viewOrdersForm.receipt"),
          subtitle: this.$t("viewOrdersForm.receipt_concat_subtitle"),
          isVisible: false,
        },
      ];
    },
    ...mapState("auth", ["authenticated", "authenticatedUser", "isFetching"]),
    ...mapFields("garage", ["tmpCarId"]),
    ...mapFields("customers", ["customer", "customerFormTabsId"]),
    ...mapFields("payments", ["payment"]),
    ...mapFields("site", ["lang"]),
    ...mapFields("common", ["countries", "cities"]),
    ...mapFields("common", ["countries", "cities"]),
    ...mapFields("cart", ["cartIsLoading"]),
    ...mapFields("orders", [
      "imageLoading",
      "comment",
      //"order",
      "fetched",
      "isFetchedOrder",
      "savingInProgress",
    ]),
    ...mapFields("statuses", [
      "order_statuses",
      "order_repairtimes_statuses",
      "order_payments_statuses",
    ]),
    /**
     * Проверим можно ли добавить в заказ новые товары и работы
     * @returns {boolean}
     */
    canGoToSearchWithOrder() {
      if (!this.order.status_payment || !this.order.status) {
        return false;
      }
      if (this.order.status_payment.id === CONSTANTS.status_payment.PAID_UP) {
        return false;
      }
      if (
        !this.order.status.system ||
        (this.order.status.id !== CONSTANTS.status_system_order.NEW &&
          this.order.status.id !== CONSTANTS.status_system_order.IN_THE_WORK)
      ) {
        return false;
      }
      return true;
    },
    isShowReceiptPrintMenuItem() {
      let value = process.env.VUE_APP_IS_SHOW_RECEIPT_PRINT;
      if (!value) return false;
      return value.toLowerCase() === "true" || parseInt(value) === 1;
    },
    shop() {
      return this.authenticatedUser.shop;
    },
    tableType() {
      let partsNum = this.order.items.filter(
        (it) => it.item_type === "part"
      ).length; //число деталей в заказе
      let repairtimesNum = this.order.items.filter(
        (it) => it.item_type === "repairtime"
      ).length; //число работ в заказе

      if (partsNum > 0 && repairtimesNum > 0) return "summary";
      if (partsNum > 0 && repairtimesNum < 1) return "parts";
      if (partsNum < 1 && repairtimesNum > 0) return "repairtimes";
      return null;

      if (this.tableItemsForShow.parts && this.tableItemsForShow.repairtimes)
        return "summary";
      if (this.tableItemsForShow.parts && !this.tableItemsForShow.repairtimes)
        return "parts";
      if (!this.tableItemsForShow.parts && this.tableItemsForShow.repairtimes)
        return "repairtimes";
    },
    logs() {
      let availibleForCustomer = [
        "change_order_payment_status",
        "change_item_status",
        "change_order_status",
        "add_payment",
      ];
      if (this.order.log.length < 1) return false;
      let result = [];
      for (let i in this.order.log) {
        let log = {};
        log.user = this.order.log[i].user.name;
        log.date = this.order.log[i].created_at;
        log.availibleForCustomer = availibleForCustomer.includes(
          this.order.log[i].action
        )
          ? '<i class="fa fa-user" aria-hidden="true"></i>&nbsp;'
          : "";
        try {
          let responsibleForChanged = null;
          switch (this.order.log[i].action) {
            case "delete_item_part":
            case "delete_item_repairtime":
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                " <b>" +
                this.order.log[i].part +
                "</b>";
              break;

            case "change_amount_repairtime":
            case "change_amount_part":
            case "change_supplier":
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                " <b>" +
                this.order.log[i].part +
                ":</b> <b>" +
                this.order.log[i].old_value +
                "</b> → <b>" +
                this.order.log[i].new_value +
                "</b>";
              break;
            case "change_price":
            case "change_purchase_price":
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                " <b>" +
                this.order.log[i].part +
                ":</b> <b>" +
                  this.formatCurrency(this.order.log[i].old_value) +
                "</b> → <b>" +
                  this.formatCurrency(this.order.log[i].new_value) +
                "</b>";
              break;
            case "change_order_payment_status":
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                ": <b>" +
                this.$t(
                  "common.paymentStatuses." + this.order.log[i].old_value
                ) +
                "</b> → <b>" +
                this.$t(
                  "common.paymentStatuses." + this.order.log[i].new_value
                ) +
                "</b>";
              break;
            case "change_part_status":
              let old_part_status = JSON.parse(this.order.log[i].old_value);
              let new_part_status = JSON.parse(this.order.log[i].new_value);
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action, [
                  this.order.log[i].part,
                ]) +
                ": <b>" +
                (old_part_status.type === "system_order_part_status"
                  ? this.$t(
                      "common.orderPartsSystemStatusNames." +
                        old_part_status.name
                    )
                  : old_part_status.name) +
                "</b> → <b>" +
                (new_part_status.type === "system_order_part_status"
                  ? this.$t(
                      "common.orderPartsSystemStatusNames." +
                        new_part_status.name
                    )
                  : new_part_status.name) +
                "</b>";
              break;
            case "change_repairtime_status":
              let old_repairtime_status = JSON.parse(
                this.order.log[i].old_value
              );
              let new_repairtime_status = JSON.parse(
                this.order.log[i].new_value
              );
              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action, [
                  this.order.log[i].part,
                ]) +
                ": <b>" +
                (old_repairtime_status.type === "system_order_repairtime_status"
                  ? this.$t(
                      "common.orderPartsSystemStatusNames." +
                        old_repairtime_status.name
                    )
                  : old_repairtime_status.name) +
                "</b> → <b>" +
                (new_repairtime_status.type === "system_order_repairtime_status"
                  ? this.$t(
                      "common.orderPartsSystemStatusNames." +
                        new_repairtime_status.name
                    )
                  : new_repairtime_status.name) +
                "</b>";
              break;
            case "change_order_status":
              let old_status = JSON.parse(this.order.log[i].old_value);
              let new_status = JSON.parse(this.order.log[i].new_value);

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                ": <b>" +
                (old_status.type == "system_order_status"
                  ? this.$t("common.orderSystemStatusNames." + old_status.name)
                  : old_status.name) +
                "</b> → <b>" +
                (new_status.type == "system_order_status"
                  ? this.$t("common.orderSystemStatusNames." + new_status.name)
                  : new_status.name) +
                "</b>";
              break;
            case "change_car":
              let oldname = JSON.parse(this.order.log[i].old_value);
              let newname = JSON.parse(this.order.log[i].new_value);

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                ": <b>" +
                oldname["name"] +
                "</b> → <b>" +
                newname["name"] +
                "</b>";
              break;
            case "add_payment":
              let value = JSON.parse(this.order.log[i].new_value);
              let text;
              if (value.type) {
                text =
                    this.formatCurrency(value.value) +
                  " [" +
                  this.$t("payments.types." + value.type) +
                  "]";
              } else {
                text = value;
              }

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                ": <b>" +
                text +
                "</b>";
              break;
            case "delete_payment":
              let valuedp = JSON.parse(this.order.log[i].new_value);
              let textdp;
              if (valuedp.type) {
                textdp =
                    this.formatCurrency(valuedp.value) +
                  " [" +
                  this.$t("payments.types." + valuedp.type) +
                  "]";
              } else {
                text = this.formatCurrency(valuedp);
              }

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                ": <b>" +
                  textdp +
                "</b>";
              break;
            case "add_cost":
              let data = JSON.parse(this.order.log[i].new_value);

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                " " +
                this.$t("costs.types." + data.name) +
                " " +
                data.comment +
                ": <b>" +
                  this.formatCurrency(data.value) +
                "</b>";
              break;
            case "delete_cost":
              let dataJS = JSON.parse(this.order.log[i].new_value);

              log.action =
                log.availibleForCustomer +
                this.$t("orderLogActions." + this.order.log[i].action) +
                " " +
                this.$t("costs.types." + dataJS.name) +
                " " +
                  dataJS.comment +
                ": <b>" +
                  this.formatCurrency(dataJS.value) +
                "</b>";
              break;
            case "comment":
              let comment = JSON.parse(this.order.log[i].new_value);
              log.action =
                log.availibleForCustomer +
                (comment.sms
                  ? '<i class="fa fa-mobile" aria-hidden="true" title="SMS"></i>&nbsp;'
                  : "") +
                (comment.email
                  ? '<i class="fa fa-envelope" aria-hidden="true" title="E-mail"></i>&nbsp;'
                  : "") +
                "<i>" +
                comment.text +
                "</i>";
              break;
            case "deleted_responsible_for":
              responsibleForChanged = JSON.parse(this.order.log[i].new_value);
              log.action =  this.$t('orderLogActions.deleted_responsible_for', [responsibleForChanged && responsibleForChanged.user_name, responsibleForChanged && responsibleForChanged.stage_name]);
              break;
            case "added_responsible_for":
              responsibleForChanged = JSON.parse(this.order.log[i].new_value);
              log.action =  this.$t('orderLogActions.added_responsible_for', [responsibleForChanged && responsibleForChanged.user_name, responsibleForChanged && responsibleForChanged.stage_name]);
              break;
            case "comment_repairtime":
              let comment_repairtime = JSON.parse(this.order.log[i].new_value);
              log.action =
                this.order.log[i].part + ": " + comment_repairtime.text;
              break;
          }
        } catch (e) {
          console.log(e);
          this.$store.dispatch(
            "common/showError",
            {
              error: `Error on parse JSON log for order #${this.order.human_number} (${this.order.id})`,
            },
            { root: true }
          );
        }
        result.push(log);
      }
      return result;
    },
    tableHeader() {
      return [
        { text: this.$t("common.part"), value: "brand", class: "text-no-wrap" },
        {
          text: this.$t("common.supplier_name"),
          value: "supplier_name",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.delivery_time"),
          value: "delivery_time",
          align: "right",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.amount"),
          value: "amount",
          align: "right",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.purchase_price"),
          value: "purchase_price",
          align: "right",
          class: "text-no-wrap",
        },
        {
          text: this.$t("common.price"),
          value: "price",
          align: "right",
          class: "text-no-wrap",
        },
        { text: this.$t("common.title"), value: "name", class: "text-no-wrap" },
        {
          text: this.$t("common.status"),
          sortable: false,
          class: "text-no-wrap",
        },
      ];
    },
    debt() {
      return (this.totalSum - this.payed).toFixed(2);
    },
    totalPurchaseSum() {
      return Object.values(this.order.items)
        .reduce((sum, item) => item.purchase_price * item.amount + sum, 0)
        .toFixed(2);
    },
    sumRepairtimes() {
      if (!this.order || !this.order.items) return 0;
      return this.order.items.reduce((sum, item) => {
        if (item.item_type === "repairtime" && !item.is_canceled) {
          return item.amount * item.price + sum;
        }
        return sum;
      }, 0);
    },
    sumParts() {
      if (!this.order || !this.order.items) return 0;
      return this.order.items.reduce((sum, item) => {
        if (item.item_type === "part" && !item.is_canceled) {
          return item.amount * item.price + sum;
        }
        return sum;
      }, 0);
    },
    totalSum() {
      return (
        (this.order &&
          this.order.total_sum &&
          parseFloat(this.order.total_sum).toFixed(2)) ||
        0
      );
      //return (Object.values(this.order.items).reduce((sum, item) => (item.price * item.amount + sum), 0)).toFixed(2)
    },
    payed() {
      if (!this.order.payments.length) return 0;
      let sum = 0;
      for (let i in this.order.payments) {
        sum += this.order.payments[i].value;
      }
      return sum.toFixed(2);
    },
    costs() {
      if (!this.order.costs.length) return 0;
      let sum = 0;
      for (let i in this.order.costs) {
        sum += this.order.costs[i].value;
      }
      return sum;
    },
  },
  methods: {
    async loadOrder(id){
      return this.order = await this.$store.dispatch("orders/orderShow", {
        id: id
      })
    },
    setOrderStatus(status) {
      if (
        parseInt(status.id) === parseInt(this.order.status.id) &&
        status.system === this.order.status.system
      ) {
        return;
      }
      if (
        status.name === "received_delivered" &&
        status.system &&
        this.isEnabledStorageV2
      ) {
        this.$vuetify.theme.dark = false;
        this.$confirm({
          title: this.$t("common.confirm"),
          text: this.$t(
            "viewOrdersForm.confirm_setting_received_delivered_status"
          ),
          cancelText: this.$t("common.no"),
          acceptText: this.$t("common.yes"),
        })
          .then(async (y) => {
            this.order.status = status;
            this.orderUpdate();
          })
          .catch((n) => {
            this.order.status = { ...this.order.status };
          });
      } else {
        this.order.status = status;
        this.orderUpdate();
      }
    },
    refreshOrderItemWindow() {
      if (this.orderItemImagesWindow.isVisible) {
        this.order.items.forEach((item) => {
          if (item.id === this.orderItemImagesWindow.item.id) {
            this.orderItemImagesWindow.item = item;
          }
        });
      }
    },
    chooseCar(car) {
      this.order.car = car;
      this.customerGarageSelectCarForm = false;
      this.orderUpdate();
    },
    showGarageForSelectCar(order) {
      if (!order.customer) return;
      this.customerGarageSelectCarForm = true;
      this.customerId = order.customer.id;
      this.customerFormTabsId = 2;
      this.carId = order.car ? order.car.id : -1;
      this.tmpCarId = this.carId;
    },
    showItemImagesWindow(item) {
      this.orderItemImagesWindow.item = item;
      this.orderItemImagesWindow.isVisible = true;
    },
    showDiagnosticWindow(item) {
      this.orderItemDiagnosticWindow.item = item;
      this.orderItemDiagnosticWindow.isVisible = true;
    },
    showReservedGoods() {
      const type = "orderItem";
      this.reservedGoodsWindow.items = [];
      this.order.items
        .filter((item) => item.item_type && item.item_type === "part")
        .forEach((item) => {
          this.reservedGoodsWindow.items.push({
            id: item.id,
            type: type,
            brand: item.brand,
            part_number: item.part_number,
            price: item.price,
            amount: item.amount,
            name: item.name,
          });
        });
      this.reservedGoodsWindow.isVisible = true;
    },
    removeOrderItemImages(id) {
      this.$store.dispatch("orders/removeOrderItemImage", {
        item_id: this.orderItemImagesWindow.item.id,
        order_id: this.orderItemImagesWindow.item.order_id,
        id,
      }).then(()=>{
        this.loadOrder(this.orderItemImagesWindow.item.order_id).then(()=>{
          this.refreshOrderItemWindow()
        })
      })
    },
    addOrderItemImages(images) {
      this.$store.dispatch("orders/uploadOrderItemImages", {
        images,
        item_id: this.orderItemImagesWindow.item.id,
        order_id: this.orderItemImagesWindow.item.order_id,
      }).then(()=>{
        this.loadOrder(this.orderItemImagesWindow.item.order_id).then(()=>{
          this.refreshOrderItemWindow()
        })
      })
    },
    orderUpdate() {
      if (this.$refs["orderForm"].validate()) {
        this.$store
          .dispatch("orders/ordersUpdate", this.order)
          .then((order) => {
            if (!order) {
              this.loadOrder(this.order.id);
            } else {
              this.$emit('updated', order)
            }
          });
      }
    },
    orderCheckResult(force = false) {
      if (!this.order) return;
      if (
        (this.order.order_check_status == "ready " ||
          this.order.order_check_id == null) &&
        force !== true
      ) {
        return;
      }
      this.$store
        .dispatch("orders/orderCheckResult", { id: this.order.id })
        .then((data) => {
          if (
            data &&
            data.result &&
            data.result.error !== "" &&
            data.result.error !== undefined
          ) {
            //this.$error(data.result.error || "unknown error");
            clearInterval(this.interval);
            clearInterval(this.interval);
          }
          if (
            data &&
            data.ready &&
            data.ready === true &&
            (data.result.error === "" || data.result.error == undefined)
          ) {
            clearInterval(this.interval);
            this.loadOrder(this.order.id);
          }
        });
    },
    orderCheck() {
      this.$store
        .dispatch("orders/orderCheck", { id: this.order.id })
        .then((data) => {
          if (data && data.status === "success") {
            this.order.order_check_id = data.task_id;
            this.interval = setInterval(() => {
              if (!this.order) return;
              if (
                this.order.order_check_status === "ready" ||
                !this.order.order_check_id
              ) {
                clearInterval(this.interval);
                return;
              }
              this.orderCheckResult(true);
            }, 3000);
          }
        });
      //this.loadOrder(this.order.id);
    },
    toggleExpanded(item) {
      if (this.expanded.filter((i) => i.id == item.id).length) {
        this.expanded = this.expanded.filter((i) => i.id !== item.id);
      } else {
        this.expanded.push(item);
      }
    },
  },
};
</script>

<style lang="css">
.no-line-select .v-input__slot:before {
  display: none !important;
}
.no-line-select .v-input__slot:after {
  display: none !important;
}
.status-circle {
  border-radius: 12px;
  width: 12px;
  height: 12px;
}
.status-square {
  border-radius: 1px;
  width: 12px;
  height: 12px;
}
.orderWrap .text-caption {
  font-size: 0.75em !important;
}

.status-square {
  border-radius: 1px;
  width: 12px;
  height: 12px;
}
</style>
